import { Trans } from '@lingui/react/macro';
import { MessageTextSquare01 } from '@untitledui/icons/MessageTextSquare01';

interface Props {
  specialInstructions: string;
}

export default function SpecialInstructionCard({ specialInstructions }: Props) {
  return (
    <div className="flex flex-row gap-4 rounded-2xl bg-utility-warning-50 p-6 text-sm">
      <MessageTextSquare01 className="hidden size-5 shrink-0 text-utility-warning-500 lg:block" />
      <div className="flex flex-col items-start">
        <h3 className="mb-2 flex flex-row gap-4 font-semibold text-primary">
          <MessageTextSquare01 className="size-5 shrink-0 text-utility-warning-500 lg:hidden" />
          <Trans>Special instructions from the researcher</Trans>
        </h3>
        <p className="text-secondary">{specialInstructions}</p>
      </div>
    </div>
  );
}
